import React from 'react';
import { getTranslatedText, SuperPop } from '@nile/components';
import { alertPolicyTypeMap } from '@nile/banyan/src/Utils/policy';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Badge } from '@superops/ui-design-system';

const StatusTagCell = (props) => {
  const { cell, intl } = props;

  const { original: alert } = cell?.row;

  if (alert?.externalSource === 'ACRONIS') {
    return (
      <Badge status="low">
        <FormattedMessage id="rmm.alertManagement.acronis.tag" />
      </Badge>
    );
  }

  return (
    alert.policy.policyType ===
      alertPolicyTypeMap.intelligentAlertingPolicyType && (
      <SuperPop
        position="top-start"
        content={getTranslatedText(
          intl,
          'rmm.alertManagement.intelligentAlerting.superTip'
        )}
        holder={
          <Badge status="info">
            <FormattedMessage id="rmm.alertManagement.intelligentAlerting.tag" />
          </Badge>
        }
      />
    )
  );
};

export default injectIntl(StatusTagCell);
